import React from 'react';
import { UniversalLink } from '@plone/volto/components';

import './ContentFeedbackBox.less';

type FeedbackItem = {
  id: string;
  title: string;
  href: string;
  ariaLabel: string;
  description: string;
};

type ContentFeedbackBoxProps = {
  title?: string;
  subtitle?: string;
  helperText?: string;
  footerText?: string;
  footerText2?: string;
  infoHref?: string;
  infoLabel?: string;
  infoAriaLabel?: string;
  items?: FeedbackItem[];
};

const defaultItems: FeedbackItem[] = [
  {
    id: 'denuncia',
    title: 'Denúncia',
    href: 'https://falabr.cgu.gov.br/Login//Identificacao/Identificacao.aspx?idFormulario=4&tipo=1&ReturnUrl=%2fpublico%2fManifestacao%2fRegistrarManifestacao.aspx%3fidFormulario%3d4%26tipo%3d1%26origem%3didp%26modo%3d',
    ariaLabel: 'Registrar denúncia no sistema Fala.BR',
    description: 'Relate irregularidades.',
  },
  {
    id: 'reclamacao',
    title: 'Reclamação',
    href: 'https://falabr.cgu.gov.br/Login//Identificacao/Identificacao.aspx?idFormulario=1&tipo=2&ReturnUrl=%2fpublico%2fManifestacao%2fRegistrarManifestacao.aspx%3fidFormulario%3d1%26tipo%3d2%26origem%3didp%26modo%3d',
    ariaLabel: 'Registrar reclamação no sistema Fala.BR',
    description: 'Registre sua insatisfação.',
  },
  {
    id: 'elogio',
    title: 'Elogio',
    href: 'https://falabr.cgu.gov.br/Login//Identificacao/Identificacao.aspx?idFormulario=1&tipo=3&ReturnUrl=%2fpublico%2fManifestacao%2fRegistrarManifestacao.aspx%3fidFormulario%3d1%26tipo%3d3%26origem%3didp%26modo%3d',
    ariaLabel: 'Registrar elogio no sistema Fala.BR',
    description: 'Compartilhe algo positivo.',
  },
  {
    id: 'sugestao',
    title: 'Sugestão',
    href: 'https://falabr.cgu.gov.br/Login//Identificacao/Identificacao.aspx?idFormulario=1&tipo=4&ReturnUrl=%2fpublico%2fManifestacao%2fRegistrarManifestacao.aspx%3fidFormulario%3d1%26tipo%3d4%26origem%3didp%26modo%3d',
    ariaLabel: 'Registrar sugestão no sistema Fala.BR',
    description: 'Envie uma ideia.',
  },
  {
    id: 'solicitacao',
    title: 'Solicitação',
    href: 'https://falabr.cgu.gov.br/Login//Identificacao/Identificacao.aspx?idFormulario=1&tipo=5&ReturnUrl=%2fpublico%2fManifestacao%2fRegistrarManifestacao.aspx%3fidFormulario%3d1%26tipo%3d5%26origem%3didp%26modo%3d',
    ariaLabel: 'Registrar solicitação no sistema Fala.BR',
    description: 'Faça um pedido.',
  },
  {
    id: 'simplifique',
    title: 'Simplifique',
    href: 'https://falabr.cgu.gov.br/Login//Identificacao/Identificacao.aspx?idFormulario=1&tipo=2&ReturnUrl=%2fpublico%2fManifestacao%2fRegistrarManifestacao.aspx%3fidFormulario%3d1%26tipo%3d2%26origem%3didp%26modo%3d',
    ariaLabel: 'Registrar manifestação simplifique no sistema Fala.BR',
    description: 'Sugira melhorias.',
  },
];

function FeedbackIcon({ type }: { type: string }) {
  switch (type) {
    case 'denuncia':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12 3 21 19H3L12 3Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M12 9v4.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
          <circle cx="12" cy="16.5" r="1" fill="currentColor" />
        </svg>
      );

    case 'reclamacao':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M7 17.5 3.5 20V7.5A2.5 2.5 0 0 1 6 5h12A2.5 2.5 0 0 1 20.5 7.5v7A2.5 2.5 0 0 1 18 17H7Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M8 10h8M8 13h5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      );

    case 'elogio':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="m12 4.5 2.16 4.38 4.84.7-3.5 3.41.83 4.82L12 15.54 7.67 17.8l.83-4.82L5 9.58l4.84-.7L12 4.5Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
        </svg>
      );

    case 'sugestao':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12 4.5a5.5 5.5 0 0 0-3.7 9.56c.8.72 1.45 1.63 1.7 2.69h4c.25-1.06.9-1.97 1.7-2.69A5.5 5.5 0 0 0 12 4.5Z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M10 19h4M10.5 21h3"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      );

    case 'solicitacao':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M14 4.5h3.5A2.5 2.5 0 0 1 20 7v10a2.5 2.5 0 0 1-2.5 2.5h-11A2.5 2.5 0 0 1 4 17V7a2.5 2.5 0 0 1 2.5-2.5H10"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M9 4.5h6v4H9z"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinejoin="round"
          />
          <path
            d="M8 12h8M8 15h5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      );

    case 'simplifique':
      return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M6 7.5h8A2.5 2.5 0 0 1 16.5 10v.5A2.5 2.5 0 0 1 14 13H8a2.5 2.5 0 0 0-2.5 2.5v1A2.5 2.5 0 0 0 8 19h10"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="m13.5 16.5 4 2.5-4 2.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );

    default:
      return null;
  }
}

export default function ContentFeedbackBox({
  title = 'Dê sua opinião sobre a qualidade do conteúdo que você acessou.',
  subtitle = 'Escolha sua manifestação em apenas um clique.',
  helperText = 'Você será direcionado(a) para o sistema Fala.BR, mas é com a EBC que estará dialogando. O Fala.BR é uma plataforma de comunicação da sociedade com a administração pública, por meio das Ouvidorias.',
  footerText = 'Sua opinião ajuda a EBC a melhorar os serviços e conteúdos ofertados ao cidadão. Por isso, não se esqueça de incluir na sua mensagem o link do conteúdo alvo de sua manifestação.',
  footerText2 = 'Para mais informações sobre a Ouvidoria da EBC, acesse a página completa',
  infoHref = 'https://www.ebc.com.br/ouvidoria',
  infoLabel = 'Mais informações sobre a Ouvidoria da EBC',
  infoAriaLabel = 'Abrir página da Ouvidoria da EBC em nova aba',
  items = defaultItems,
}: ContentFeedbackBoxProps) {
  return (
    <section
      className="content-feedback-box"
      aria-labelledby="content-feedback-box-title"
    >
      <div className="content-feedback-box__inner">
        <div className="content-feedback-box__header">
          <h2
            id="content-feedback-box-title"
            className="content-feedback-box__title"
          >
            {title}
          </h2>

          <p className="content-feedback-box__subtitle">{subtitle}</p>
        </div>

        <div
          className="content-feedback-box__grid"
          role="list"
          aria-label="Tipos de manifestação disponíveis"
        >
          {items.map((item) => (
            <div
              key={item.id}
              className="content-feedback-box__item"
              role="listitem"
            >
              <UniversalLink
                href={item.href}
                className={`content-feedback-box__card content-feedback-box__card--${item.id}`}
                aria-label={item.ariaLabel}
                title={item.title}
                openLinkInNewTab
              >
                <div className="content-feedback-box__card-top">
                  <span
                    className="content-feedback-box__icon"
                    aria-hidden="true"
                  >
                    <FeedbackIcon type={item.id} />
                  </span>
                </div>

                <div className="content-feedback-box__card-content">
                  <span className="content-feedback-box__label">
                    {item.title}
                  </span>

                  <span className="content-feedback-box__item-description">
                    {item.description}
                  </span>
                </div>
              </UniversalLink>
            </div>
          ))}
        </div>

        <div className="content-feedback-box__footer">
          <p className="content-feedback-box__text">{helperText}</p>
          <p className="content-feedback-box__text">{footerText}</p>
          <p className="content-feedback-box__text">
            {footerText2}{' '}
            <UniversalLink
              href={infoHref}
              className="content-feedback-box__inline-link"
              aria-label={infoAriaLabel}
              title={infoLabel}
              openLinkInNewTab
            >
              Clique aqui
            </UniversalLink>
            .
          </p>
        </div>
      </div>
    </section>
  );
}
